import { useNavigate,useLocation } from "react-router-dom";
import { useState,useEffect } from "react";
import { SelectionGroup,SelectionItem } from "../Selection/Selection";
import { LightIcon } from "../../AssetComponents/Images";
import { createPortal } from 'react-dom';
import { useRef } from "react";

export const RentalNavigation = () => {
  const [current, setCurrent] = useState(-1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    if (!path || path === "") {
      setCurrent(0);
      navigate("/rent/all"); 
    } else {
      switch (path) {
        case "all":
          setCurrent(0);
          break;
        case "long":
          setCurrent(1);
          break;
        case "short":
          setCurrent(2);
          break;
        default:
          setCurrent(0);
          navigate("/rent/all");
          break;
      }
    }
  }, [location, navigate]);

  const getCurrentLabel = () => {
    switch (current) {
      case 0: return "All";
      case 1: return "Long term";
      case 2: return "Short term";
      default: return "All";
    }
  };

  const handleMobileNavigation = (path, index) => {
    navigate(path);
    setCurrent(index);
    setMobileMenuOpen(false);
  };

  const handleToggleMenu = () => {
    if (!mobileMenuOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX
      });
    }
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      {/* Desktop Version - unchanged */}
      <div className="hidden lg:block">
        <SelectionGroup
          defaultItem={current}
          className="border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
        >
          <SelectionItem
            SelectedItem={
              <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <div className="text-black font-semibold">All</div>
                <LightIcon />
              </div>
            }
            UnselectedItem={
              <div
                onClick={() => navigate("/rent/all")}
                className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
              >
                <div className="text-[#959595]">All</div>
              </div>
            }
          />
          <SelectionItem
            SelectedItem={
              <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <div className="text-black font-semibold">Long term</div>
                <LightIcon />
              </div>
            }
            UnselectedItem={
              <div
                onClick={() => navigate("/rent/long")}
                className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
              >
                <div className="text-[#959595]">Long term</div>
              </div>
            }
          />
          <SelectionItem
            SelectedItem={
              <div className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <div className="text-black font-semibold">Short term</div>
                <LightIcon />
              </div>
            }
            UnselectedItem={
              <div
                onClick={() => navigate("/rent/all")}
                className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center"
              >
                <div className="text-[#959595]">Short term</div>
              </div>
            }
          />
        </SelectionGroup>
      </div>

      {/* Mobile Version - Compact Hamburger Menu */}
      <div className="lg:hidden">
        <div className="relative">
          <button
            ref={buttonRef}
            onClick={handleToggleMenu}
            className="py-[4px] cursor-pointer bg-white hover:bg-[#f6f6f6] rounded-[10px] px-[14px] flex items-center justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
            style={{ minWidth: 'fit-content', maxWidth: '120px' }}
          >
            <div className="flex flex-col gap-1">
              <div className="w-3 h-0.5 bg-gray-600"></div>
              <div className="w-3 h-0.5 bg-gray-600"></div>
              <div className="w-3 h-0.5 bg-gray-600"></div>
            </div>
            <span className="text-black font-semibold text-sm truncate">{getCurrentLabel()}</span>
            <svg 
              className={`w-3 h-3 transform transition-transform ${mobileMenuOpen ? 'rotate-180' : ''}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

                     {/* Mobile Dropdown Menu */}
           {mobileMenuOpen && createPortal(
                           <div 
                             className="fixed w-32 bg-white border border-gray-200 rounded-lg shadow-lg z-[99999999]" 
                             style={{ 
                               zIndex: 99999999,
                               top: dropdownPosition.top,
                               left: dropdownPosition.left
                             }}
                           >
              <div
                onClick={() => handleMobileNavigation("/rent/all", 0)}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-50 text-xs ${current === 0 ? 'bg-purple-50 text-purple-700 font-semibold' : 'text-gray-700'}`}
              >
                All
              </div>
              <div
                onClick={() => handleMobileNavigation("/rent/long", 1)}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-50 text-xs ${current === 1 ? 'bg-purple-50 text-purple-700 font-semibold' : 'text-gray-700'}`}
              >
                Long term
              </div>
              <div
                onClick={() => handleMobileNavigation("/rent/short", 2)}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-50 text-xs ${current === 2 ? 'bg-purple-50 text-purple-700 font-semibold' : 'text-gray-700'}`}
              >
                Short term
              </div>
            </div>,
            document.body
          )}

          {/* Backdrop */}
          {mobileMenuOpen && (
            <div 
              className="fixed inset-0 z-[99999998]" 
              onClick={() => setMobileMenuOpen(false)}
              style={{ zIndex: 99999998 }}
            />
          )}
        </div>
      </div>
    </>
  );
};